/**
 * banner-fit-text.js
 *
 * Auto-shrinks the description text inside collection-page banners so all
 * banners stay at the same fixed height (set in CSS as `height: 240px` on
 * `.custom-collection-banner-main--regular`) without clipping any content.
 *
 * How it works: the CSS exposes three custom properties on the banner —
 *   --banner-desc-size (default 21px)
 *   --banner-desc-last-size (default 12px)
 *   --banner-subtitle-size (default 40px)
 * — that the description's font-size rules read via var(...) !important.
 * If a banner's text content overflows its cell, this script lowers those
 * variables in 1px steps until the content fits, with a hard floor so text
 * never becomes unreadable. Most collections fit at default sizes; only
 * outliers like long multi-paragraph descriptions get scaled down.
 */
(function () {
  'use strict';

  var DEFAULTS = { desc: 28, last: 12, subtitle: 40 };
  var FLOORS = { desc: 12, last: 9, subtitle: 18 };
  var MAX_ATTEMPTS = 40;

  function fitBanner(banner) {
    var textCell = banner.querySelector('.custom-collection-banner-text');
    if (!textCell) return;

    // Reset to defaults so we measure against the original sizes.
    banner.style.removeProperty('--banner-desc-size');
    banner.style.removeProperty('--banner-desc-last-size');
    banner.style.removeProperty('--banner-subtitle-size');

    // Force a layout pass so scrollHeight reflects defaults.
    void textCell.offsetHeight;

    if (textCell.scrollHeight <= textCell.clientHeight) return; // already fits

    var desc = DEFAULTS.desc;
    var last = DEFAULTS.last;
    var subtitle = DEFAULTS.subtitle;

    for (var i = 0; i < MAX_ATTEMPTS; i++) {
      if (textCell.scrollHeight <= textCell.clientHeight) break;

      var atFloor = (desc === FLOORS.desc) && (last === FLOORS.last) && (subtitle === FLOORS.subtitle);
      if (atFloor) break;

      if (desc > FLOORS.desc) desc -= 1;
      if (last > FLOORS.last) last -= 0.5;
      if (subtitle > FLOORS.subtitle) subtitle -= 1;

      banner.style.setProperty('--banner-desc-size', desc + 'px');
      banner.style.setProperty('--banner-desc-last-size', last + 'px');
      banner.style.setProperty('--banner-subtitle-size', subtitle + 'px');
    }
  }

  function fitAll() {
    var banners = document.querySelectorAll('.custom-collection-banner-main--regular');
    for (var i = 0; i < banners.length; i++) fitBanner(banners[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitAll);
  } else {
    fitAll();
  }

  // Refit when web fonts finish loading (font metrics change content height).
  if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(fitAll);
  }

  // Refit on viewport resize, debounced.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitAll, 150);
  });
})();
